import Vue from 'vue'
import Vuex from 'vuex'
import orderInfo from './modules/orderInfo'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: { orderInfo }
})
